export enum TariffChangeType {
    Upgrade = 1,
    Downgrade
}